import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../static/css/AccountHeader.css';
import logo from '../static/images/images/a-logo-transperent.png';

class AccountHeader extends Component {
    constructor() {
        super();
        this.onSignOut = this.onSignOut.bind(this);
    }

    onSignOut() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('upcoming_event');
        window.location.href = '/signin';
    }

    render() {
        // Session-aware on purpose. This header also renders on public pages — /rules and the
        // /how-to-* pages — which the iOS/Android apps open in a webview that never carries a web
        // session. Showing "Sign Out" there offered logged-out visitors, and every in-app viewer,
        // a control that does nothing they'd expect. The logo always renders; only the auth links
        // are gated. Read at render time rather than held in state: every sign-out/auth failure
        // hard-navigates, so this component is remounted whenever the token changes.
        const isSignedIn = !!localStorage.getItem('token');
        return (
            <div className="account-header">
                <Link to="/"><img className="account-header-logo" src={logo} alt="" /></Link>
                {isSignedIn && (
                    <div className="account-header-auth-links">
                        <button type="button" className="account-header-auth-link" onClick={this.onSignOut}>Sign Out</button>
                    </div>
                )}
            </div>
        );
    }
}

export default AccountHeader;
